import { getProductTemplateChecklist, getShortProductTemplateInfo } from 'api/operations/productServiceV2';
import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { getRootStoreInstance, RootStore } from 'store/rootStore';
import { ProductTemplate, ProductTemplateChecklist } from 'types/productServiceV2';

export const INITIAL_PRODUCT_TEMPLATE_CHECKLIST: ProductTemplateChecklist = {
  checklistOptions: [],
};

export default class RFQProductChecklistStore {
  rootStore: RootStore;

  private _isLoading = false;
  private _productTemplate: ProductTemplate | null = null;
  private _checklist: ProductTemplateChecklist = INITIAL_PRODUCT_TEMPLATE_CHECKLIST;

  // Getters
  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get productTemplate(): ProductTemplate | null {
    return this._productTemplate;
  }

  public get checklist(): ProductTemplateChecklist {
    return this._checklist;
  }

  // Setters
  private setLoading(loadingStatus: boolean): void {
    this._isLoading = loadingStatus;
  }

  private setChecklist(checklist: ProductTemplateChecklist): void {
    this._checklist = checklist;
  }

  private setProductTemplate(productTemplate: ProductTemplate | null): void {
    this._productTemplate = productTemplate;
  }

  // Api calls
  public async getProductTemplateChecklist(templateId: string): Promise<void> {
    this.setLoading(true);
    const res = await getProductTemplateChecklist(templateId);
    runInAction(() => {
      if (res?.checklist) this.setChecklist(res.checklist);
      this.setLoading(false);
    });
  }

  public async getProductTemplateSidebarInfo(templateId: string): Promise<void> {
    const res = await getShortProductTemplateInfo(templateId);
    runInAction(() => {
      if (res) this.setProductTemplate(res);
    });
  }

  public resetTemplateInfo(): void {
    this.setProductTemplate(null);
    this.setChecklist(INITIAL_PRODUCT_TEMPLATE_CHECKLIST);
  }

  constructor() {
    this.rootStore = getRootStoreInstance();
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const PageStoreContext = createContext(new RFQProductChecklistStore());

export const useRFQProductChecklistStore = (): RFQProductChecklistStore => {
  return useContext(PageStoreContext);
};

export { PageStoreContext };
